// removed by extract-text-webpack-plugin
module.exports = {"blokk":"nrk-v17-static-blokk","large":"nrk-v17-static-large","blokk__content":"nrk-v17-static-blokk__content","hx":"nrk-v17-static-hx","blokk__separator":"nrk-v17-static-blokk__separator","blokk__line":"nrk-v17-static-blokk__line","blokk__toppline":"nrk-v17-static-blokk__toppline","blokk__bottomline":"nrk-v17-static-blokk__bottomline"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/enblokksvisning/Blokk/index.css
// module id = 285
// module chunks = 6 7